/**
 * 運營總決策台 D10（Overseas patch 229）
 */
export const STORE_OPS_CEO_DESK_MENU_IDS = {
  group: 990167,
  desk: 990168,
  view: 990169,
  decide: 990454
}

export default STORE_OPS_CEO_DESK_MENU_IDS



// WEBPACK FOOTER //
// ./src/constants/storeOpsCeoDesk.js